import { searchSuppliersQuery } from "@/api/supplier";
import { useDebouncedQuery } from "@/api/utils";
import { saveHref } from "@/utils/assume-role";
import { Command, List } from "@givenwell/command-palette";
import { StoreIcon } from "@givenwell/core-solid-icons";
import { useNavigate } from "@tanstack/react-router";
import { useState } from "react";

export const searchSuppliersCommand: Command = {
  id: "search-suppliers",
  title: "Search Suppliers",
  icon: <StoreIcon width="21" height="21" />,
  Component: ({ fallbackText }) => {
    const [searchText, setSearchText] = useState(fallbackText || "");
    const { data, isFetching } = useDebouncedQuery(searchSuppliersQuery(searchText, 1, 20), 150);
    const navigate = useNavigate();
    return (
      <List
        navigationTitle="Search Suppliers"
        searchText={searchText}
        onSearchTextChange={setSearchText}
        searchBarPlaceholder="Search for suppliers..."
        isLoading={isFetching}
        content={
          data?.items.map(supplier => ({
            title: `${supplier.name}`,
            actions: [
              {
                title: `Assume Role`,
                onAction: ({ close }) => {
                  saveHref();
                  navigate({
                    to: "/supplier/$supplierId",
                    params: { supplierId: supplier.id },
                  });
                  close();
                },
              },
            ],
          })) || []
        }
      />
    );
  },
};
